/**
 * R6-C — suggerimento typo del dominio email (non bloccante). Se il dominio
 * digitato non è tra quelli comuni ma dista ≤2 edit (Levenshtein) da uno di essi,
 * suggerisce il più vicino. I domini aziendali legittimi (fuori lista, distanza >2)
 * non vengono disturbati.
 */
// i18n-ignore-file: qui dentro le stringhe «parola.parola» sono DOMINI, non
// chiavi i18n, e check-i18n le leggerebbe come chiavi orfane. Il file non
// contiene testo tradotto: escluderlo per intero non nasconde nulla.
export const EMAIL_DOMAINS = [
  'gmail.com', 'hotmail.com', 'hotmail.it', 'outlook.com', 'outlook.it',
  'live.com', 'live.it', 'yahoo.com', 'yahoo.it', 'libero.it', 'tiscali.it',
  'virgilio.it', 'alice.it', 'icloud.com', 'pec.it', 'legalmail.it', 'tin.it',
];

export function levenshtein(a: string, b: string): number {
  const m = a.length;
  const n = b.length;
  const d: number[][] = Array.from({ length: m + 1 }, () => new Array<number>(n + 1).fill(0));
  for (let i = 0; i <= m; i++) d[i][0] = i;
  for (let j = 0; j <= n; j++) d[0][j] = j;
  for (let i = 1; i <= m; i++) {
    for (let j = 1; j <= n; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
    }
  }
  return d[m][n];
}

/** Dominio suggerito (≤2 edit da uno noto, e non già noto) o null. */
export function suggestEmailDomain(email: string): string | null {
  const at = email.lastIndexOf('@');
  if (at < 0) return null;
  const domain = email.slice(at + 1).trim().toLowerCase();
  if (!domain || EMAIL_DOMAINS.includes(domain)) return null;
  let best: string | null = null;
  let bestDist = 3;
  for (const cand of EMAIL_DOMAINS) {
    const dist = levenshtein(domain, cand);
    if (dist > 0 && dist <= 2 && dist < bestDist) { best = cand; bestDist = dist; }
  }
  return best;
}

/** Email completa con dominio corretto, o null se non c'è suggerimento. */
export function suggestedEmail(email: string): string | null {
  const suggestion = suggestEmailDomain(email);
  if (!suggestion) return null;
  const at = email.lastIndexOf('@');
  return email.slice(0, at + 1) + suggestion;
}
